import { displayField } from "./atsCvFormEngine.js";

/** @typedef {{ key: string, label: string, description: string, optional?: boolean }} WizardStepDef */

/** @type {WizardStepDef[]} */
export const ATS_CV_WIZARD_STEPS = [
    {
        key: "import",
        label: "ইম্পোর্ট",
        description: "PDF ইম্পোর্ট",
        optional: true,
    },
    {
        key: "personal",
        label: "ব্যক্তিগত",
        description: "নাম, যোগাযোগ",
    },
    {
        key: "summary",
        label: "সারাংশ",
        description: "পেশাগত সারাংশ",
        optional: true,
    },
    {
        key: "experience",
        label: "অভিজ্ঞতা",
        description: "কাজের ইতিহাস",
    },
    {
        key: "education",
        label: "শিক্ষা",
        description: "ডিগ্রি ও প্রতিষ্ঠান",
    },
    {
        key: "projects",
        label: "প্রোজেক্ট",
        description: "ঐচ্ছিক প্রজেক্ট",
        optional: true,
    },
    {
        key: "skills",
        label: "দক্ষতা",
        description: "স্কিল, সার্টিফিকেট",
        optional: true,
    },
    {
        key: "custom",
        label: "কাস্টম",
        description: "অতিরিক্ত সেকশন",
        optional: true,
    },
];

export const ATS_CV_WIZARD_LAST_INDEX = ATS_CV_WIZARD_STEPS.length - 1;

function hasExperience(form) {
    return (form.experiences || []).some(
        (exp) => displayField(exp.jobTitle) && displayField(exp.company)
    );
}

function hasEducation(form) {
    return (form.education || []).some(
        (edu) => displayField(edu.degree) && displayField(edu.institution)
    );
}

/**
 * @param {import("./atsCvFormEngine.js").INITIAL_ATS_CV_FORM} form
 * @param {string} stepKey
 */
export function isWizardStepComplete(form, stepKey) {
    switch (stepKey) {
        case "import":
            return Boolean(
                displayField(form.fullName) ||
                    displayField(form.summary) ||
                    hasExperience(form) ||
                    hasEducation(form)
            );
        case "personal":
            return (
                Boolean(displayField(form.fullName)) &&
                Boolean(displayField(form.email)) &&
                Boolean(displayField(form.phone))
            );
        case "summary":
            return Boolean(displayField(form.summary));
        case "experience":
            return hasExperience(form);
        case "education":
            return hasEducation(form);
        case "projects":
            return (form.projects || []).some((p) => displayField(p.name));
        case "skills":
            return Boolean(
                displayField(form.skills) ||
                    displayField(form.certifications) ||
                    displayField(form.languages)
            );
        case "custom":
            return (form.customSections || []).some(
                (s) => displayField(s.title) && displayField(s.content)
            );
        default:
            return false;
    }
}

/**
 * @param {import("./atsCvFormEngine.js").INITIAL_ATS_CV_FORM} form
 * @param {number} activeStep
 */
export function getWizardProgress(form, activeStep = 0) {
    const steps = ATS_CV_WIZARD_STEPS.map((step, index) => ({
        index,
        ...step,
        complete: isWizardStepComplete(form, step.key),
    }));

    const total = steps.length;
    const safeActive = Math.max(0, Math.min(activeStep, total - 1));

    /** How far through the wizard the user has navigated (not “fields filled”). */
    const journeyPercent = Math.round(((safeActive + 1) / total) * 100);

    return {
        steps,
        total,
        activeStep: safeActive,
        journeyPercent,
    };
}
